import styled from 'styled-components'
import colors from '../../constants/colors'
import Flex from '../Flex'

export const BreadcrumbWrapper = styled(Flex)`
  color: ${colors.black25};
  svg {
    path {
      fill: ${colors.black25};
    }
  }
`
